/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getFeed.defs'
export { main as default } from './getFeed.defs'
